module.exports = __webpack_public_path__ + "static/media/carousel14.94b47d30.jpeg";